import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

const Name = styled.span`
  margin-bottom: 20px;
  text-transform: uppercase;
  font: ${({ theme }) => `${theme.fontWeightHeavy} 11px/1 ${theme.fontFamilyBody}`};
  color: ${props => (props.highlight ? props.theme.bodyColor : props.theme.secondaryColor)};
`;

const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 21px;
  align-items: center;

  > span.fa {
    color: ${props => props.theme.primaryColor};
    font-size: 24px;
    font-weight: ${props => props.theme.fontWeightHeavy};

    &.fa-circle {
      opacity: 50%;
    }
  }
`;

const Connector = styled.div`
  margin-bottom: 10.5px; /* half of icon height minus half connector height */
  height: 3px;
  width: 90px;
  border: none;
  background-color: ${props => props.theme.primaryColor};
  opacity: ${props => (props.index <= props.active ? '100%' : '50%')};
`;

const LegendContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-bottom: 25px;
  margin-top: ${props => (props.theme.isMobile ? '25px' : '0')};
`;

const Step = ({
  name, active, index,
}) => {
  const iconClass = {
    'fa-check-circle': active > index,
    'fa-circle-o': active === index,
    'fa-circle': active < index,
  };
  return (
    <StepContainer>
      <Name highlight={active === index}>{name}</Name>
      <span className={classNames('fa', iconClass)} />
    </StepContainer>
  );
};

Step.propTypes = {
  name: PropTypes.string.isRequired,
  active: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

export default function StepLegend({ steps, activeStepIndex }) {
  return (
    <LegendContainer>
      {steps.map((step, index) => {
        const props = { active: activeStepIndex, index };
        return (
          <React.Fragment key={step}>
            {!!index && <Connector {...props} />}
            <Step name={step} {...props} />
          </React.Fragment>
        );
      })}
    </LegendContainer>
  );
}

StepLegend.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeStepIndex: PropTypes.number.isRequired,
};
